import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExamCategory } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-category-select',
  templateUrl: './category-select.component.html',
  styleUrls: ['./category-select.component.scss']
})
export class CategorySelectComponent {
  questionCategories: IExamCategory[] = [];

  @Input() selectedCategory: string = '';
  @Input() readonly: boolean = false;
  @Output() selectedCategoryChange = new EventEmitter<string>();
  constructor(private examService: ExamService, private snackBar: SnackbarService,) { }

  async ngOnInit() {
    let exam = this.examService.selectedExams[0];
    this.questionCategories = await this.examService.getExamCategories(exam.id) as any;
  }
  onCategoryChange(value: string) {
    this.selectedCategory = value;
    this.selectedCategoryChange.emit(value);
  }

}
